import { Component } from '@angular/core';

@Component({
  selector: 'app-day-selector',
  templateUrl: './day-selector.component.html',
  styleUrls: ['./day-selector.component.scss'],
})
export class DaySelectorComponent {
  day: string = new Date().toISOString();

  currentDay: string;

  constructor() {}

  goToPreviousDay() {
    //Esta funcion va hacia el dia anterior
    console.log(this.day);
  }

  goToNextDay() {
    // Esta funcion va hacia el dia siguiente
    console.log(this.day);
  }

  goToLastDay() {
    // Esta funcion va al ultimo dia del que se tienen actividades
    console.log(this.day);
  }

  updateDay(event) {
    // Esta funcion actualizará el dia
    console.log(this.day);
  }

  onPickedDay(event) {
    this.day = event.detail.value;
    console.log(this.day);
  }
}
